<script lang="ts" setup>
import { SettingsBreadcrumbsModel } from "@/components/menu-breadcrumbs";
import MenuBreadcrumbs from "@/components/menu-breadcrumbs/menu-breadcrumbs.vue";
import { QueueTasksModel } from "@/components/sidebar/models";
import { computed, onMounted, PropType, ref, watch } from "vue";
import { TirPmInput } from "tir-components";
import { EditQueueAdapterService } from "../adapter-service";

/**API сервис */
const apiService = new EditQueueAdapterService();

/**Параметры */
const props = defineProps({
  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
});

/**Имя очереди */
const innerName = ref("");

/**Информация об очереди */
const settingsBreadcrumbs = computed(
  () =>
    new SettingsBreadcrumbsModel({
      NamespaceId: props.queue?.NamespaceId,
      GroupId: props.queue?.ParentGroupId,
      QueueId: props.queue?.Id?.toString(),
    }),
);

/**После рендера */
onMounted(() => setInnerName());

/**Отслеживание изменений очереди */
watch(() => props.queue, setInnerName, { deep: true });

/**Установка значения поля innerName */
function setInnerName() {
  innerName.value = props.queue.Name || "";
}
/**Смена имени очереди */
const changeName = () => {
  if (!innerName.value.length) {
    innerName.value = props.queue.Name;
    return;
  }

  (document?.activeElement as HTMLElement)?.blur?.();

  apiService.updateName(props.queue.Id, innerName.value);
  props.queue.Name = innerName.value;

  document.dispatchEvent(
    new CustomEvent("update-queue-name", {
      detail: {
        QueueId: props.queue.Id,
        Name: innerName.value,
      },
    }),
  );
};
</script>
<template>
  <div class="edit-queue-modal-main">
    <div class="edit-queue-modal-main_breadcrumbs">
      <div class="edit-queue-modal-main_breadcrumbs_title" v-text="'Местонахождение'" />
      <MenuBreadcrumbs no-route :settings="settingsBreadcrumbs" />
    </div>
    <div class="edit-queue-modal_border" />
    <TirPmInput
      label="Название очереди"
      v-model="innerName"
      @enter="changeName"
      @blur="changeName"
    />
  </div>
</template>
<style lang="scss" scoped>
.edit-queue-modal-main {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  &_breadcrumbs {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    &_title {
      font-weight: medium;
    }
  }
}
</style>
